var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.46973C3.239 1.46973 1 3.70873 1 6.46973V14.4697C1 17.2307 3.239 19.4697 6 19.4697H14C16.761 19.4697 19 17.2307 19 14.4697V6.46973C19 3.70873 16.761 1.46973 14 1.46973H6ZM16 3.46973C16.552 3.46973 17 3.91773 17 4.46973C17 5.02173 16.552 5.46973 16 5.46973C15.448 5.46973 15 5.02173 15 4.46973C15 3.91773 15.448 3.46973 16 3.46973ZM10 5.46973C12.761 5.46973 15 7.70873 15 10.4697C15 13.2307 12.761 15.4697 10 15.4697C7.239 15.4697 5 13.2307 5 10.4697C5 7.70873 7.239 5.46973 10 5.46973ZM10 7.46973C9.20435 7.46973 8.44129 7.7858 7.87868 8.34841C7.31607 8.91102 7 9.67408 7 10.4697C7 11.2654 7.31607 12.0284 7.87868 12.591C8.44129 13.1537 9.20435 13.4697 10 13.4697C10.7956 13.4697 11.5587 13.1537 12.1213 12.591C12.6839 12.0284 13 11.2654 13 10.4697C13 9.67408 12.6839 8.91102 12.1213 8.34841C11.5587 7.7858 10.7956 7.46973 10 7.46973Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0c964b4ed97abad41b21e0aedf7ba119.svg";
export { ForwardRef as ReactComponent };